import { useEffect, useState } from "react";

const COMPACT_MONITORING_MEDIA = "(max-width: 1200px)";

const useCompactMonitoringLayout = () => {
  const [isCompact, setIsCompact] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(COMPACT_MONITORING_MEDIA).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(COMPACT_MONITORING_MEDIA);
    const onChange = () => setIsCompact(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isCompact;
};

export default useCompactMonitoringLayout;
